import { RefObject } from 'react'


export const arePasswordsEqual = (firstPassword: RefObject<string>) => (secondPassword: string) => {
  return firstPassword.current !== secondPassword && 'Пароли не совпадают'
}
